// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__ClxRH","card":"not-allowed-screen_card__TK9vi","text":"not-allowed-screen_text__NoFGw"};